//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Importer.js";
let d=[[[0,"AllLevelsOfDetail",1,0],[0,"AngularTolerance",1,0],[0,"FileUnits",1,0],[0,"GenerateOneModel",1,0],[0,"HideSmoothEdges",1,0],[0,"MoreSummaryDetails",1,0],[0,"SuppressWarningMessages",1,0]],[],[]];
SPLM.VRMLImporter = class extends SPLM.Importer{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.VRMLImporter";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.VRMLImporter.AngularToleranceType = Object.freeze({
    "Coarse" : "Coarse", "Medium" : "Medium", "Fine" : "Fine"});

SPLM.VRMLImporter.FileUnitsType = Object.freeze({
    "Meters" : "Meters", "Millimeters" : "Millimeters", "Inches" : "Inches"});

export default SPLM;